export default {
	apiKey: "AIzaSyBW2ltVZ9Y9EFraPPQWjnUayQFEgTB55eU",
	authDomain: "matrix.atgrapevine.com",
	databaseURL: "https://grapevinematrix.firebaseio.com",
	projectId: "grapevinematrix",
	storageBucket: "grapevinematrix.appspot.com",
	messagingSenderId: "835024428178"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js